import React from 'react';
import { PageItemRenderer, PageSwitcherRenderer } from 'ds/components/pagination';
import { Page, PageSwitcher } from 'ds/components/pagination/styled';
import { Text } from 'ds/components/typography';
import { State as RouteState } from 'config/routes';
import ChevronDown from 'assets/svg/chevron-down.svg';
import { LinkPageItem } from './LinkPageItem';

export const createPageItemRenderer = (route: RouteState, dataAutoPrefix?: string, noHrefForPageToRender: boolean = false): PageItemRenderer => {
  const { name: routeName, params: routeParams } = route;

  return ({ page: pageToRender, isActive, isWide }) => {
    const { page, ...paramsWithoutPage } = routeParams;
    const nextParams = pageToRender === 1 ? paramsWithoutPage : { ...routeParams, page: pageToRender };

    const dataAuto = dataAutoPrefix && `${dataAutoPrefix}${pageToRender}`;

    return (
      <Page onlyIcon={!isWide} isActive={isActive} isWide={isWide} noActiveStyles>
        <LinkPageItem
          data-auto={dataAuto}
          routeName={routeName}
          routeParams={nextParams}
          noHrefForPageToRender={noHrefForPageToRender && (page === pageToRender || (pageToRender === 1 && !page))}
        >
          <Text>{pageToRender}</Text>
        </LinkPageItem>
      </Page>
    );
  };
};

export const createPageSwitcherRenderer = (route: RouteState, dataAutoPrefix?: string): PageSwitcherRenderer => {
  const { name: routeName, params: routeParams } = route;

  return ({ page: pageToRender, type, isDisabled }) => {
    const { page, ...paramsWithoutPage } = routeParams;
    const nextParams = pageToRender === 1 ? paramsWithoutPage : { ...routeParams, page: pageToRender };

    const dataAuto = dataAutoPrefix && `${dataAutoPrefix}${pageToRender}`;

    return (
      <PageSwitcher onlyIcon mode="ghost" arrowType={type} disabled={isDisabled}>
        <LinkPageItem
          data-auto={dataAuto}
          routeName={routeName}
          routeParams={nextParams}
        >
          <ChevronDown width={24} height={24} />
        </LinkPageItem>
      </PageSwitcher>
    );
  };
};
